<template>
  <div>
    <el-dialog :visible.sync="visible" width="800px" title="正式数据">
        <div style="margin-bottom:20px;">
            <el-select v-model="shareType">
                  <el-option v-for="item in shareTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
        </div>
      <el-table :data="realData" border>
          <el-table-column label="周期ID" prop="cycleId"></el-table-column>
          <el-table-column label="用户ID" prop="userId"></el-table-column>
          <el-table-column label="用户账号" prop="userAccount"></el-table-column>
          <el-table-column label="是否是真实用户数据">
              <template slot-scope="scope">
                  <span v-if="scope.row.realData">是</span>
                  <span v-else>否</span>
              </template>
          </el-table-column>
          <el-table-column label="类型">
              <template slot-scope="scope">
                  {{scope.row.shareType | shareType}}
              </template>
          </el-table-column>
          <el-table-column label="是否有效">
              <template slot-scope="scope">
                  <span v-if="scope.row.valid">是</span>
                  <span v-else>否</span>
              </template>
          </el-table-column>
          <el-table-column label="数据量" prop="amount"></el-table-column>
      </el-table>
      <pagination
        :size="pager.size"
        :page="pager.page"
        :total="realDataTotal"
        @pageChanged="handlePageChanged"
      >
      </pagination>
    </el-dialog>
  </div>
</template>
<script>
import '../store.js';
import Pagination from "../../../components/pagination";
import { mapState,mapActions } from 'vuex';
import {SHARE_TYPE} from '../constant.js'
export default {
  name: "contractFeeTempData",
  data() {
    return {
      visible: false,
      createVisible: false,
      cycleId: '',
      shareType: 1,
      pager: {
        page: 1,
        size: 10
      },
      form: {
          dataNum: '',
          shareType: 1,
          userAccount: '',
          userId: ''
      }
    };
  },
  computed: {
      ...mapState('contractFee', ['realData', 'realDataTotal']),
      shareTypes() {
          return [
              {
                  value: 1,
                  label: SHARE_TYPE[1]
              },
              {
                  value: 2,
                  label: SHARE_TYPE[2]
              },
              {
                  value: 3,
                  label: SHARE_TYPE[3]
              }
          ]
      }
  },
  methods: {
      ...mapActions('contractFee', ['getRealData']),
      getData(pagerVal) {
          this.getRealData({
              cycleId: this.cycleId,
              shareType: this.shareType,
              ...pagerVal
          });
      },
      showData(cycleId) {
          this.cycleId = cycleId;
          this.getData(this.pager);
          this.visible = true;
      },
      handlePageChanged(val) {
          this.getData(val);
      }
  },
  watch: {
      shareType(newVal, oldVal) {
          this.getData(this.pager);
      }
  },
  filters: {
      shareType(val) {
          return SHARE_TYPE[parseInt(val)];
      }
  },
  components: {
    Pagination
  }
};
</script>
<style lang="less" scoped>
    .btn-wrap {
        text-align: center;
    }
</style>
